export const ORDER_LOG_EVENT = {
  CLICKED_ADDITIONAL_ORDER_CATEGORIES: 'clicked_additional_order_categories',
  CLICKED_SKIP_ADDITIONAL_ORDER: 'clicked_additional_order_skip_button',
  EXITED_ADDITIONAL_ORDER_PAGE: 'exited_additional_order_page',
  IMPRESSED_ADDITIONAL_ORDER_PRODUCT: 'impressed_additional_order_product',
  CLICKED_ADDITIONAL_ORDER_CATEGORY_TAB: 'clicked_additional_order_category_tab',
  CLICKED_ADDITIONAL_ORDER_ADD_TO_CART: 'clicked_additional_order_add_cart',
  CLICKED_ADDITIONAL_ORDER_REMOVE_FROM_CART: 'clicked_additional_order_remove_cart',
  CLICKED_SUBMIT_ADDITIONAL_ORDER: 'clicked_additional_order_submit_button',
} as const;
